const locale: Locale = {
  ko: {
    emailVerification: '이메일로 온 인증 코드를 입력하세요',
  },
  en: {
    emailVerification: 'verification code',
  },
}

export default locale
